/**
 * Story 054 — TanStack Query keys for the sites feature.
 */
import type { ListSitesParams } from "./types.js";

export const sitesKeys = {
  all: ["sites"] as const,
  lists: () => [...sitesKeys.all, "list"] as const,
  list: (params: ListSitesParams) =>
    [...sitesKeys.lists(), params] as const,
  detail: (id: string) => [...sitesKeys.all, "detail", id] as const,
};
